import { b64ToBlobWithoutOrientation } from 'functions/file/b64ToBlobWithoutOrientation';
import {
  isDevelopment,
  isProduction,
  isStaging,
} from 'config/environment/environment.helper';

type DocImages = {
  first?: string;
  second?: string;
};

export const getUrl = async (inputSrc: string) => {
  if (!inputSrc) {
    throw new Error('Argument inputSrc not provided');
  }

  let src = inputSrc;
  if (isProduction() || isStaging() || isDevelopment()) {
    src = await convertRemoteImageToBase64(inputSrc);
  }
  const blob = await b64ToBlobWithoutOrientation(src);
  return URL.createObjectURL(blob);
};

export const prepareFiles = async (docImages: DocImages) => {
  let firstUrl = '';
  let secondUrl = '';
  if (docImages?.first) {
    firstUrl = await getUrl(docImages.first);
  }
  if (docImages?.second) {
    secondUrl = await getUrl(docImages.second);
  }
  return {
    firstUrl,
    secondUrl,
  };
};

const convertRemoteImageToBase64 = (url: string): Promise<string> => {
  return new Promise((resolve) => {
    fetch(url)
      .then((response) => response.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = () => {
          const base64data = reader.result;
          resolve(base64data as string);
        };
      });
  });
};

// const convertImageToBase64 = async (src: string): Promise<string> => {
//   return new Promise((resolve) => {
//     const image = new Image();
//     image.crossOrigin = 'use-credentials';
//     image.onload = () => {
//       const canvas = document.createElement('canvas');
//       const ctx = canvas.getContext('2d');
//       if (ctx) {
//         canvas.height = image.naturalHeight;
//         canvas.width = image.naturalWidth;
//         ctx.drawImage(image, 0, 0);
//         const dataUrl = canvas.toDataURL();
//         resolve && resolve(dataUrl);
//       } else {
//         resolve && resolve('');
//       }
//     };
//     image.src = src;
//   });
// };
